import useFilter from 'hooks/useFilter'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import AgGrid from 'components/ui/agGrid'
import { useAuthStore } from 'store/useAuthStore'
import {
    tutorsColDefs,
    programColDefs,
    programPivotColDefs,
    tutorsPivotColDefs,
    inventoryColDefs,
    rentalColDefs,
} from './columnDefs'
import styles from './dataTable.module.scss'

const DataTable = () => {
    // hooks
    const { getSearchParam } = useFilter()
    const { pathname } = useLocation()
    const [type, subtype] = pathname.replace('/data-table/', '').split('/')
    const pageType = subtype || type

    const initialGridType = getSearchParam('gridType') || 'normal'

    const isMaster = useAuthStore(state => state.isMaster())
    const { userInfo } = useAuthStore()

    // 마스터: URL 파라미터(필터 선택) 또는 기본값 '전체'
    // 일반 사용자: 본인 지역
    const region = isMaster
        ? (getSearchParam('regionId') || '전체')
        : userInfo?.regionId

    const colDefs = useMemo(() => {
        const colDefsMap = {
            program: programColDefs,
            tutors: tutorsColDefs,
            tools: {
                inventory: inventoryColDefs,
                rental: rentalColDefs,
            },
            rental: rentalColDefs,
            statistics_program: programPivotColDefs,
            statistics_tutor: tutorsPivotColDefs,
        }

        let baseCols
        if (type === 'tools') {
            baseCols = colDefsMap.tools?.[subtype] || []
        } else {
            baseCols = colDefsMap[pageType] || []
        }

        // 마스터가 아닌 경우: 지역 필터에 본인 지역만 표시
        if (!isMaster && userInfo?.regionId && pageType === 'program') {
            return baseCols.map(col => {
                if (col.field === 'regionId') {
                    return {
                        ...col,
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            values: [userInfo.regionId],
                            suppressSelectAll: true,
                        },
                    }
                }
                return col
            })
        }

        return baseCols
    }, [type, subtype, pageType, isMaster, userInfo?.regionId])

    const defaultColDef = useMemo(
        () => ({
            flex: 1,
            minWidth: 130,
            enablePivot: initialGridType === 'pivot',
            enableRowGroup: true,
            enableValue: true,
            filter: true,
            floatingFilter: true,
        }),
        [initialGridType],
    )

    const pageTypeTitle = {
        program: '교육실적',
        tutors: '강사정보',
        inventory: '자산 관리',
        rental: '대여 반납',
    }
    const title = pageTypeTitle[pageType]

    // const handleGridTypeChange = type => {
    //     const params = new URLSearchParams(search)
    //     params.set('gridType', type)
    //     navigate(`${pathname}?${params.toString()}`)
    // }

    return (
        <div className={styles.container}>
            <span className="h7">{title} Ag-Grid 데이터 테이블</span>

            {/* <div className={styles.button_wrap}>
                <Button onClick={() => handleGridTypeChange('normal')}>일반 그리드</Button>
                <Button onClick={() => handleGridTypeChange('pivot')}>피봇 그리드</Button>
            </div> */}
            <AgGrid
                pageType={pageType === 'tutors' ? 'tutor' : pageType}
                gridType={initialGridType}
                colDefs={colDefs}
                defaultColDef={defaultColDef}
                region={region}
            />
        </div>
    )
}
export default DataTable
